import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import {
  provideRouter,
  withEnabledBlockingInitialNavigation,
  withPreloading,
} from '@angular/router';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';

import { routes } from './app.routes';
import { provideClientHydration } from '@angular/platform-browser';
import { accountingChangeDetectionInterceptor } from './core/interceptors/accounting-change-detection.interceptor';
import { accountingCompanyInterceptor } from './core/interceptors/accounting-company.interceptor';
import { authInterceptor } from './core/interceptors/auth.interceptor';
import { CustomPreloadingStrategy } from './core/routing/custom-preloading.strategy';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(
      routes,
      withEnabledBlockingInitialNavigation(),
      withPreloading(CustomPreloadingStrategy),
    ),
    provideClientHydration(),
    provideHttpClient(
      withFetch(),
      withInterceptors([
        accountingChangeDetectionInterceptor,
        authInterceptor,
        accountingCompanyInterceptor,
      ]),
    ),
  ]
};
